import { Dialog, Toast } from 'vant';
import store from '@/store';
import Vue from 'vue'
const token = Vue.prototype.$bsUtils.getUrlParams('token')
localStorage.setItem('dq_token', token)
console.log(token);
const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};
export function authLogin(res, pageType, loginMobile) {
  let { status, data: userInfo, message } = res;
  let mobile = pageType == 'login' ? loginMobile : (userInfo?.mobile??'');
  // 10701015   商管无法进行               break
  // 10701014   查询到店长店员              注册
  // 10701013   没查询到店长店员（游客）    登录页
  // 10700022   没查询到店长店员（游客）    登录页
  // 10700271   没查询到店长店员（游客）    登录页
  // 200        正常                      合同签署
  if (status == '10701015') {
    Dialog.alert({
      message: '检测到您是商管员工，不可使用该功能',
      showConfirmButton: pageType == 'login' ? true : false,
    }).then(() => { });
  } else if (status == '200') {

    if (userInfo.individualId || userInfo.companyTraders) {
      // 个体商户或管理员
      store.commit('base/setUserInfo', userInfo);
      let base = JSON.stringify({
        token: isWechat() ? userInfo.token : token,
        userId: userInfo.id,
      });
      if (isWechat()) {
        window.location.replace(`${window.location.origin}${window.location.pathname}#/wxAuth/business_choice?base=${base}`)
      } else {
        window.location.replace(`${window.location.origin}${window.location.pathname}#/auth/business_choice?token=${isWechat() ? userInfo.token : token}`)

      }
    } else {
      Toast('您不是个体商户或企业商户,请注册后登录');
      if(isWechat()){
        window.location.replace(`${location.origin}${location.pathname}#/dq/login`)
      }else{
        window.location.replace(`${location.origin}${location.pathname}#/dq/agreement?mobile=${mobile}`)
      }
    }

  } else if (status == '10701014') {

    if (userInfo.individualId || userInfo.companyTraders) {
      // 个体商户或管理员
      store.commit('base/setUserInfo', userInfo);
      let base = JSON.stringify({
        token: isWechat() ? userInfo.token : token,
        userId: userInfo.id,
      });
      if (isWechat()) {
        window.location.replace(`${window.location.origin}${window.location.pathname}#/wxAuth/business_choice?base=${base}`)
      } else {
        window.location.replace(`${window.location.origin}${window.location.pathname}#/auth/business_choice?token=${isWechat() ? userInfo.token : token}`)
      }
    } else {
      Toast('您不是个体商户或企业商户,请注册后登录');
      if(isWechat()){
        window.location.replace(`${location.origin}${location.pathname}#/dq/login`)
      }else{
        window.location.replace(`${location.origin}${location.pathname}#/dq/agreement?mobile=${mobile}`)
      }
    }
  } else if (status == '10701013' || status == '10700022' || status == '10700271') {
    if (pageType == 'login') {
      Dialog.alert({
        message: '您不是万达商户，请先注册成为万达商户',
      }).then(() => {
      });
    } else {
      if(isWechat()){
        window.location.replace(`${location.origin}${location.pathname}#/dq/login`)
      }else{
        window.location.replace(`${location.origin}${location.pathname}#/dq/agreement?mobile=${mobile}`)
      }
    }
  } else {
    Dialog.alert({
      message: message,
    }).then(() => { });
  }
}

export const mobileReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/

export const rules = {
  mobileRules: [
    {
      required: true,
      message: '',
      trigger: 'onChange',
    },
    {
      validator: value => {
        const reg = mobileReg;
        // return value.length === 11 ? true : false;
        return reg.test(value);
      },
      message: '手机号格式不正确',
      trigger: 'onChange',
    },
  ],

  name: [
    {
      required: true,
      message: '',
      trigger: 'onChange',
    },
    {
      validator: value => {
        return value.length < 2 || value.length > 50 ? false : true;
      },
      message: '姓名格式不正确',
      trigger: 'onChange',
    },
  ],
  idNo: [
    {
      required: true,
      message: '',
      trigger: 'onChange',
    },
    {
      validator: value => {
        const reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        return reg.test(value);
      },
      message: '身份证号格式不正确',
      trigger: 'onChange',
    },
  ],
  email: [
    {
      required: true,
      message: '',
      trigger: 'onChange',
    },
    {
      validator: value => {
        // const reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
        const emailReg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
        let formatEmail = value.split(' ').join('')
        return emailReg.test(formatEmail);
      },
      message: '邮箱格式不正确',
      trigger: 'onChange',
    },
  ],
};
